import { Provider } from '@angular/core';
import { WorkspaceMembersFacade } from './workspace-members.facade';
import { affiliatedUserStoreProviders, workspaceMembersStoreProviders } from '../../../providers/store.providers';

/**
 * Providers for the WorkspaceMembersFacade.
 * Includes AffiliatedUsersStore providers for the organization users list and
 * WorkspaceMembersState/Effects for the workspace-members management flow.
 */
export const workspaceMembersFacadeProviders: Provider[] = [
  ...affiliatedUserStoreProviders(),
  ...workspaceMembersStoreProviders(),
  WorkspaceMembersFacade,
];
